import React, { useEffect } from 'react'
import { Statistic } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { BackButton, BasicSettingWrapper, CustomSettingWrapper, BasicInfoWrapper, SettingWrapper, SubTitle, SegmentInfo, SegmentInfoTitle, SegmentInfoWrapper } from '../segment.styled'

function SegmentDetail (props) {
  const { goBackPath, viewOnly, detailOnly, data: data2 } = props
  const { t: ln_t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { state } = location || {}
  const { data = data2 } = state || {}
  const { name, dataExport, previewCount, previewStatus, interval, maxCount, UISetting, isInvoice, rules } = data || {}
  const { profile, category, ...segments } = UISetting || {}

  const goBack = () => navigate(goBackPath, { state: { type: 'segment', prevViewOnly: viewOnly } })

  useEffect(() => { if (!data) return goBack() }, [])

  const capitalized = str => str?.charAt(0)?.toUpperCase() + str?.slice(1)

  const detailComponent = (list, mode) => list?.map(({ key, name, title, type }) => <div key={key}>{mode} &gt; {type} &gt; {name || title}</div>)
  const detailComponentInv = (i, idx) => <div key={idx}>{i?.operator} &gt; {i?.col} &gt; {i?.val}</div>
  const segmentDetail = isInvoice
    ? <SegmentInfo detailOnly={detailOnly}>
        <SegmentInfoTitle>{ln_t('segment.segment')}</SegmentInfoTitle>
        {rules?.map(detailComponentInv)}
      </SegmentInfo>
    : <SegmentInfoWrapper detailOnly={detailOnly}>
      {profile?.length
        ? <SegmentInfo detailOnly={detailOnly}>
            <SegmentInfoTitle>Profile</SegmentInfoTitle>
            {detailComponent(profile, ln_t('segment.include'))}
          </SegmentInfo>
        : ''}
      {Object.keys(segments || {})?.map(key => {
        const { include, exclude } = segments[key]
        return (
          <SegmentInfo key={key} detailOnly={detailOnly}>
            <SegmentInfoTitle>{ln_t('segment.segment')} #{key}</SegmentInfoTitle>
            {detailComponent(Object.values(include)?.flat(), ln_t('segment.include'))}
            {detailComponent(Object.values(exclude)?.flat(), ln_t('segment.exclude'))}
          </SegmentInfo>
        )
      })}
    </SegmentInfoWrapper>

  return detailOnly
    ? segmentDetail
    : <>
        <BackButton>
          <ArrowLeftOutlined onClick={() => goBack()} />
          {ln_t('segment.segment')} {ln_t('segment.detail')}
        </BackButton>
        <SettingWrapper>
          <BasicSettingWrapper>
            <SubTitle>{ln_t('util.basicInfo')}</SubTitle>
            <BasicInfoWrapper>
              <Statistic title={ln_t('util.name')} value={name || '-'} />
              <Statistic title={ln_t('target.activity')} value={`${interval} ${ln_t('criteria.days')}`} />
              <Statistic title={ln_t('target.limit')} value={maxCount || ln_t('target.unlimited')} />
              <Statistic title={ln_t('segment.dataExport')} value={dataExport || '-'} />
              <Statistic title={ln_t('segment.quantity')} value={previewCount} />
              <Statistic title={ln_t('util.status')} value={capitalized(previewStatus || '-')} />
            </BasicInfoWrapper>
          </BasicSettingWrapper>
          <CustomSettingWrapper>
            <SubTitle>{ln_t('segment.segment')} {ln_t('target.detail')}</SubTitle>
            {segmentDetail}
          </CustomSettingWrapper>
        </SettingWrapper>
      </>
}

export default SegmentDetail
